// Enums
export enum StatusPedido {
  Pendente = 'Pendente',
  Concluido = 'Concluido',
  Cancelado = 'Cancelado'
}

export enum StatusEncomenda {
  Aguardando = 'Aguardando',
  EmProducao = 'EmProducao',
  Pronto = 'Pronto',
  Entregue = 'Entregue'
}

export enum TipoMovimentacao {
  Entrada = 'Entrada',
  Saida = 'Saida'
}

export enum TipoUsuario {
  Administrador = 'Administrador',
  GerenteEstabelecimento = 'GerenteEstabelecimento',
  FuncionarioEstabelecimento = 'FuncionarioEstabelecimento',
}

// DTOs
export interface IngredienteInfo {
  ingredienteId: number;
  quantidade: number;
}

export interface CategoriaProduto {
  id: number;
  nome: string;
}

export interface Produto {
  id: number;
  nome: string;
  descricao: string;
  precoUnitario: number;
  custo: number;
  tempoPreparoMinutos: number;
  ativo: boolean;
  sobEncomenda: boolean;
  categoriaProdutoId?: number | null;
  categoriaProdutoNome?: string | null;
  urlFoto?: string;
  dataCriacao: string;
  dataUltimaAlteracao?: string;
  ingredientes: IngredienteInfo[];
  sabores?: string[];
}

export interface Ingrediente {
  id: number;
  nome: string;
  quantidadeEstoque: number;
  unidadeMedidaId: number;
  unidadeMedidaSigla: string;
  estoqueMinimo?: number;
  limiarAlerta: number;
  abaixoDoLimiar: boolean;
}

export interface Cliente {
  id: number;
  nome: string;
  telefone: string;
  email?: string;
  endereco?: string;
  notas: string[];
  dataCriacao: string;
}

export interface Pedido {
  id: number;
  numeroMesa?: number;
  dataHora: string;
  tipoPagamentoId?: number;
  status: StatusPedido;
  statusPedidoId: number;
  statusDescricao: string;
  valorSubtotal: number;
  desconto: number;
  valorTotal: number;
  valorEstornado: number;
  itens: ItemPedido[];
  usuarioId?: number;
  nomeFuncionario?: string;
}

export interface MesaAbertaDto {
  id: number;
  numeroMesa?: number;
  dataHora: string;
  itens: ItemPedido[];
  valorSubtotal: number;
  desconto: number;
  valorTotal: number;
}

export interface ItemPedido {
  id: number;
  produtoId: number;
  nomeProduto: string;
  quantidade: number;
  precoUnitario: number;
  valorTotal: number;
  sabor?: string;
}

export interface Encomenda {
  id: number;
  clienteId?: number | null;
  nomeCliente: string;
  contatoCliente?: string;
  estabelecimentoId: number;
  dataHoraEntrega: string;
  retirada: boolean;
  enderecoEntrega?: string;
  status: StatusEncomenda;
  observacoes?: string;
  desconto: number;
  valorTotal: number;
  valorEntrada: number;
  entradaPaga: boolean;
  itens: ItemEncomenda[];
}

export interface ItemEncomenda {
  id: number;
  produtoId: number;
  produtoNome: string;
  quantidade: number;
  precoUnitario: number;
  subtotal: number;
}

export interface TipoPagamento {
  id: number;
  descricao: string;
}

export interface StatusPedidoDTO {
  id: number;
  descricao: string;
}

export interface Usuario {
  id: number;
  nome: string;
  email: string;
  tipo: TipoUsuario;
  estabelecimentoId?: number;
  ativo: boolean;
  comissaoPercentual?: number;
  dataCriacao: string;
}

export interface Estabelecimento {
  id: number;
  nome: string;
  endereco: string;
  telefone: string;
  quantidadeMesas: number;
  capacidadeDiariaPorData: { [key: string]: number };
}

// Request DTOs
export interface CriarProdutoRequest {
  nome: string;
  descricao: string;
  precoUnitario: number;
  custo: number;
  tempoPreparoMinutos: number;
  sobEncomenda: boolean;
  categoriaProdutoId?: number | null;
  ingredientes?: IngredienteInfo[];
  sabores?: string[];
}

export interface AtualizarProdutoRequest {
  nome: string;
  descricao: string;
  precoUnitario: number;
  custo: number;
  tempoPreparoMinutos: number;
  sobEncomenda: boolean;
  categoriaProdutoId?: number | null;
  ingredientes?: IngredienteInfo[];
  sabores?: string[];
}

export interface CriarIngredienteRequest {
  nome: string;
  quantidadeInicial: number;
  unidadeMedidaId: number;
  limiarAlerta: number;
}

export interface RegistrarMovimentacaoRequest {
  ingredienteId: number;
  tipo: TipoMovimentacao;
  quantidade: number;
  motivo?: string;
}

export interface CriarClienteRequest {
  nome: string;
  telefone: string;
  estabelecimentoId: number;
  email?: string;
  endereco?: string;
}

export interface AtualizarClienteRequest {
  nome: string;
  telefone: string;
  email?: string;
  endereco?: string;
}

export interface RegistrarPedidoRequest {
  numeroMesa?: number;
  tipoPagamentoId?: number;
  desconto: number;
  pago?: boolean;
  usuarioId?: number;
  itens: {
    produtoId: number;
    quantidade: number;
    sabor?: string;
  }[];
  dataHora?: string;
}

export interface AdicionarItemPedidoRequest {
  produtoId: number;
  quantidade: number;
  sabor?: string;
}

export interface FecharMesaRequest {
  tipoPagamentoId: number;
}

export interface PagamentoParcialItemRequest {
  itemPedidoId: number;
  quantidade: number;
}

export interface PagamentoParcialRequest {
  tipoPagamentoId: number;
  itens: PagamentoParcialItemRequest[];
}

export interface PagamentoParcialResponse {
  pedidoPagoId: number;
  valorPago: number;
  itensRestantes: number;
  valorRestante: number;
  mesaFechada: boolean;
}

export interface CriarEncomendaRequest {
  nomeCliente: string;
  contatoCliente?: string;
  clienteId?: number | null;
  estabelecimentoId: number;
  dataHoraEntrega: string;
  retirada: boolean;
  enderecoEntrega?: string;
  observacoes?: string;
  desconto: number;
  valorEntrada: number;
  entradaPaga: boolean;
  itens: {
    produtoId: number;
    quantidade: number;
  }[];
}

export interface AtualizarEncomendaRequest {
  nomeCliente: string;
  contatoCliente?: string;
  dataHoraEntrega: string;
  retirada: boolean;
  enderecoEntrega?: string;
  observacoes?: string;
  desconto: number;
  valorEntrada: number;
  entradaPaga: boolean;
  itens?: {
    produtoId: number;
    nomeProduto: string;
    precoUnitario: number;
    quantidade: number;
  }[];
}

export interface LoginRequest {
  email: string;
  senha: string;
}

export interface LoginResponse {
  id: number;
  nome: string;
  email: string;
  tipo: TipoUsuario;
  estabelecimentoId?: number;
  token: string;
}

// Dashboard Stats
export interface DashboardStats {
  totalVendasHoje: number;
  encomendasHoje: number;
  itensProducao: number;
  ingredientesBaixoEstoque: number;
  ultimasVendas: PedidoResumido[];
  encomendasDoDia: EncomendaResumida[];
}

export interface PedidoResumido {
  id: number;
  dataHora: string;
  valorTotal: number;
  status: string;
}

export interface EncomendaResumida {
  id: number;
  clienteNome: string;
  dataHoraEntrega: string;
  status: string;
  valorTotal: number;
}

// Reports
export interface RelatorioVendasRequest {
  dataInicio: string;
  dataFim: string;
}

export interface RelatorioVendasResponse {
  dataInicio: string;
  dataFim: string;
  totalVendas: number;
  totalEncomendas: number;
  totalGeral: number;
  quantidadePedidos: number;
  quantidadeEncomendas: number;
  ticketMedioPedidos: number;
  ticketMedioEncomendas: number;
  vendasPorDia: VendaDiaria[];
  produtosMaisVendidos: ProdutoMaisVendido[];
  vendasPorMetodoPagamento: VendaPorMetodoPagamento[];
  topClientes: ClienteTopComprador[];
}

export interface VendaDiaria {
  data: string;
  totalPedidos: number;
  totalEncomendas: number;
  total: number;
  quantidadePedidos: number;
  quantidadeEncomendas: number;
}

export interface ProdutoMaisVendido {
  produtoId: number;
  nomeProduto: string;
  quantidadeVendida: number;
  valorTotal: number;
}

export interface VendaPorMetodoPagamento {
  metodoPagamento: string;
  quantidade: number;
  valorTotal: number;
  percentual: number;
}

export interface ClienteTopComprador {
  clienteId: number;
  nomeCliente: string;
  quantidadeCompras: number;
  valorTotal: number;
}

// Encomendas Report
export interface RelatorioEncomendasRequest {
  dataInicio: string;
  dataFim: string;
}

export interface RelatorioEncomendasResponse {
  dataInicio: string;
  dataFim: string;
  totalEncomendas: number;
  quantidadeTotal: number;
  quantidadeAguardando: number;
  quantidadeEmProducao: number;
  quantidadePronto: number;
  quantidadeEntregue: number;
  ticketMedio: number;
  encomendasPorDia: EncomendaDiaria[];
  produtosMaisEncomendados: ProdutoMaisEncomendado[];
  topClientes: ClienteTopEncomendas[];
  encomendasPorStatus: EncomendaPorStatus[];
}

export interface EncomendaDiaria {
  data: string;
  total: number;
  quantidade: number;
  quantidadeRetirada: number;
  quantidadeEntrega: number;
}

export interface ProdutoMaisEncomendado {
  produtoId: number;
  nomeProduto: string;
  quantidadeVendida: number;
  valorTotal: number;
}

export interface ClienteTopEncomendas {
  clienteId: number;
  nomeCliente: string;
  quantidadeEncomendas: number;
  valorTotal: number;
}

export interface EncomendaPorStatus {
  status: string;
  quantidade: number;
  valorTotal: number;
  percentual: number;
}

// Fechamento de Caixa
export interface FechamentoCaixaItemDto {
  produtoId: number;
  nomeProduto: string;
  quantidade: number;
  precoUnitario: number;
  custoUnitario: number;
  valorVenda: number;
  valorCusto: number;
}

export interface FechamentoCaixaPedidoDto {
  id: number;
  numeroMesa?: number;
  dataHora: string;
  valorTotal: number;
  custoTotal: number;
  itens: FechamentoCaixaItemDto[];
  usuarioId?: number;
  nomeFuncionario?: string;
}

export interface ComissaoFuncionarioDto {
  usuarioId: number;
  nomeFuncionario: string;
  totalVendas: number;
  percentual: number;
  valorComissao: number;
}

export interface FechamentoCaixaResponse {
  data: string;
  pedidos: FechamentoCaixaPedidoDto[];
  valorTotalPedidos: number;
  custoProdutosTotal: number;
  custoFixo: number;
  lucroLiquido: number;
  comissoes: ComissaoFuncionarioDto[];
  totalComissoes: number;
}

// Fechamento de Caixa - Encomendas
export interface FechamentoCaixaEncomendaDto {
  id: number;
  nomeCliente: string;
  dataHoraEntrega: string;
  valorTotal: number;
  desconto: number;
  custoTotal: number;
  itens: FechamentoCaixaItemDto[];
}

export interface FechamentoCaixaEncomendaResponse {
  data: string;
  encomendas: FechamentoCaixaEncomendaDto[];
  valorTotalEncomendas: number;
  custoProdutosTotal: number;
  custoFixo: number;
  lucroLiquido: number;
}
